// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"03feab1d","453":"db1452c3","732":"d0126be7"}[chunkId] + ".chunk.js";
};